<template>
  <div>
    <div id="rates" class="d-flex flex-column justify-content-top align-items-left" v-if='ratesLg'>
        <table id="ratesTable">
          <thead>
            <tr>
              <th></th>
              <th>
                 <div id="header" class="d-flex flex-column justify-content-center align-items-center">
                    <div class="title">{{ $tlang(lg1, 'novotel.rates.dayRate') }}</div>
                    <div class="subtitle">{{ $tlang(lg2, 'novotel.rates.dayRate') }}</div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <component :is="rates.type === 'rate' ? 'RowRates' : 'RowServices'" class="rowa" v-for="(rates, index) in ratesLg" :key="index" :ratesLg='rates'></component>
          </tbody>
        </table>
    </div>
  </div>
</template>

<script>
import RowRates from './rowRates'
import RowServices from './rowServices'

export default {
  components: {
    RowRates,
    RowServices,
  },
  name: 'MercureRatesHorizontalV2Rates',
  props: {
    ratesLg: Object
  },
  computed: {
    lg1 () {
      return this.$store.getters.site.get('rates').get('data').languages[0].name.toLowerCase()
    },
    lg2 () {
      return this.$store.getters.site.get('rates').get('data').languages[1].name.toLowerCase()
    }
  }
}
</script>

<style lang="scss" scoped>
$srcWidth: 1920;
$srcHeight: 1200;
@import "../../../../_mercure2021.scss";

#rates {
  width: 100%;
  height: 100%;

  #ratesTable {
    @include heightPercent(688);
    width: 100%;

    thead {
      border-bottom: 1px solid $grey;

      #header {
        width: 100%;
        @include heightPercent(58);
        text-align: center;
        font-family: "Montserrat-Bold";
        @include fontSize(22);
        border-left: solid 1px $grey; 

        .title {
          //@include widthPercent(184);
          color: $grey;
        }

        .subtitle {
          //@include widthPercent(184);
          color: $lightGrey;
        }
      }
    }

    tbody {
      .rowa:nth-of-type(n+6){
        display:none!important;
      }
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/components/mercure/rates/horizontal/v2/rates/rates.vue